import { render, staticRenderFns } from "./collectionTimeConfiguration.vue?vue&type=template&id=5683fcdc&scoped=true"
import script from "./collectionTimeConfiguration.vue?vue&type=script&lang=js"
export * from "./collectionTimeConfiguration.vue?vue&type=script&lang=js"
import style0 from "./collectionTimeConfiguration.vue?vue&type=style&index=0&id=5683fcdc&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5683fcdc",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/work/jenkins/workspace/重构-快递前端-ui/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5683fcdc')) {
      api.createRecord('5683fcdc', component.options)
    } else {
      api.reload('5683fcdc', component.options)
    }
    module.hot.accept("./collectionTimeConfiguration.vue?vue&type=template&id=5683fcdc&scoped=true", function () {
      api.rerender('5683fcdc', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/collectionCenter/BasicData/collectionTimeConfiguration.vue"
export default component.exports